import useDefinedContext from "hooks/useDefinedContext";
import { OnboardingTooltipContext } from "../OnboardingTooltip";

function useOnboardingTooltip() {
  return useDefinedContext(OnboardingTooltipContext);
}

export default useOnboardingTooltip;
